export default "__VITE_ASSET__BUxx6ZK2__"